import { UploadFileToVectorParams } from "../types/requestInputs";
import { UploadVectorResponse } from "../types/requestsOutputs";
import { MessageResponse } from "../types/types";
import { fetchAPI } from "./utils";

// Upload a document to a vector store (auto-picks if not specified) and stores ID in prisma
export const uploadFileToVector = async ({
    token,
    vectorId,
    documentUrl,
    documentName,
    companyRagFolderId,
}: UploadFileToVectorParams): Promise<UploadVectorResponse> => {
    return fetchAPI<UploadVectorResponse>(
        "/upload-file-vector",
        "POST",
        { vectorId, documentUrl, documentName, companyRagFolderId },
        token,
    );
};

// Delete document from a specific vector store and ID from prisma
export const deleteVectorDocument = async ({
    token,
    vectorId,
    fileId,
}: {
    token: string;
    vectorId?: string;
    fileId: string;
}): Promise<MessageResponse> => {
    return fetchAPI<MessageResponse>("/delete-vector-document", "POST", { vectorId, fileId }, token);
};
